import { render, staticRenderFns } from "./LogoGithub.vue?vue&type=template&id=61d08a08"
import script from "./LogoGithub.vue?vue&type=script&lang=js"
export * from "./LogoGithub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports